export interface LoginDto {
  email: string;
  password: string;
}

export interface OsbukNetLoginDto {
  email: string;
  password: string;
}

export interface AccessTokenDto {
  access_token: string;
  refresh_token: string;
  role: string;
}

export interface RefreshTokenDto {
  token: string;
}

export enum Role {
  ADMIN = "admin",
  USER = "user",
  OSBUK_USER = "osbuk_user"
}

export interface OsbukLoginDto {
  sonuc: string;
  token: string;
  expires_at: string;
  mesaj: string;
}

export interface OsbukLoginTokenDto {
  sonuc: string;
  token: string;
  mesaj: string;
}

export interface UserInfo {
  user_name: string;
  user_email: string;
  user_osb: string;
  created_at: string;
}
